import { createContext } from 'react'

const UserContext = createContext(

    {
        codigo_usuario: null,
        password: null,
        nombre_completo: null,
        id_area: null,
        estado_usuario: null,
        ip: null,
        id_usuario: null,
        puerto: null
    }


);


export default UserContext;